import React from "react";
import {useDispatch, useSelector} from "react-redux";

import {SetQuestionPracticeSkillsUpdatedAction} from "../../actions/question_actions";

export default function () {
    const dispatch = useDispatch();
    const question_practice_skills_updated = useSelector(state => state.question_practice_skills_updated);
    const selected_assignment_index = useSelector(state => state.selected_assignment_index);
    const question_practice_skill_updated = question_practice_skills_updated[selected_assignment_index];

    if (question_practice_skill_updated.mode === 'ai') {
        return (
            <div className='my-4'>
                <h5>Grading Instructions</h5>
                <div>
                    {question_practice_skill_updated.grading_instructions.map((instruction, index) => {
                        return (
                            <div key={'instruction_' + index}>
                                <div className='d-flex flex-row align-items-center flex-gap-5'>
                                    <h3><label className="col-form-label">{index}</label></h3>
                                    <textarea
                                        className="form-control flex-1"
                                        value={instruction ? instruction : ''}
                                        onChange={event => {
                                            const question_practice_skills_updated_x = JSON.parse(JSON.stringify(question_practice_skills_updated));
                                            question_practice_skills_updated_x[selected_assignment_index].grading_instructions[index] = event.target.value;
                                            dispatch(SetQuestionPracticeSkillsUpdatedAction(question_practice_skills_updated_x));
                                        }}
                                        placeholder="Instructions"
                                        rows={5}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    return null;
}
